import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = ({ sizes }) => ({
    root: {
        textAlign: 'center',
        width: '100%',
        marginTop: sizes.baseSize+'px',
        color: '#ffffff',
        border: 'none',
        fontFamily: "'zx_spectrum7_boldregular', sans",
        fontSize: '2em',
        padding: '0 0.75em',
    },
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
});

class RankingPlaceholder extends Component {
    render() {
        const { intl, classes } = this.props;
        return (
            <div className={classNames(classes.root)}>
                {intl['LOCALE.RANKING.PLACEHOLDER']}
            </div>
        )
    }
}

export default inject(mapper)(
    withStyles(styles)(RankingPlaceholder)
);